export default {
  retail: {
    breadcrumbHome: 'Početna',
    breadcrumbSolutions: 'Rješenja',
    breadcrumbCurrent: 'Trgovina i ugostiteljstvo',
    hero: {
      eyebrow: 'Trgovina i ugostiteljstvo',
      title: 'Više sigurnosti u trgovinama i ugostiteljstvu',
      lead: 'Ulaz, blagajna, skladište i pristup kuhinji – štitimo vaše poslovanje od krađe i vandalizma bez ometanja kupaca.',
    },
    points: {
      title: 'Točke nadzora za trgovinu i ugostiteljstvo',
      lead: 'Svaka trgovina i ugostiteljski objekt ima vlastita rizična područja. Kamere postavljamo točno tamo gdje čine razliku.',
      items: {
        '0': { title: 'Ulaz i izlog', desc: 'Prva točka nadzora: kamere na ulazu dokumentiraju tko dolazi i odlazi te odvraćaju već pri ulasku.' },
        '1': { title: 'Zona blagajne', desc: 'Blagajna i prostor plaćanja najosjetljivija su točka u trgovini. Diskretne kamere osiguravaju bez uznemiravanja kupaca.' },
        '2': { title: 'Prodajna površina', desc: 'Pregled cijele površine: širokokutne kamere otkrivaju sumnjiva kretanja među policama i prolazima.' },
        '3': { title: 'Skladište i dostava', desc: 'Prijem robe, skladište i pristupi osoblja: ovdje nastaju praznine pri dovozu i odvozu robe. Zatvaramo ih.' },
        '4': { title: 'Šank i pristup kuhinji', desc: 'U ugostiteljstvu su šank i pristup kuhinji kritična područja. Robusne kamere podnose vlagu i toplinu.' },
        '5': { title: 'Vanjska terasa', desc: 'Terasa i vanjski stolovi pozivaju lopove, posebno navečer. Kamere otporne na vremenske uvjete paze.' },
      },
    },
    protection: {
      eyebrow: 'Zaštita od krađe',
      title: 'Manje inventurnih gubitaka, više sigurnosti',
      lead: 'Krađa u trgovini i inventurne razlike svake godine koštaju velike iznose. Dobro postavljene kamere smanjuju gubitke i daju upotrebljive snimke.',
      items: {
        '0': { title: 'Nadzor blagajne', desc: 'Oštre snimke blagajne i prostora plaćanja – za potpunu dokumentaciju u sporovima i manipulacijama.' },
        '1': { title: 'Izlozi i pristupi', desc: 'Odvraćanje i razjašnjenje kod vandalizma ili provale – od izloga do stražnjeg ulaza.' },
        '2': { title: 'Zapisi događaja', desc: 'Kretanje, prelazak linije ili događaji na vratima pokreću snimanje i push obavijesti – točno kad je važno.' },
      },
    },
    gastro: {
      eyebrow: 'Ugostiteljstvo',
      title: 'Robusna tehnika za šank, kuhinju i terasu',
      lead: 'Para, masnoća i vlaga postavljaju posebne zahtjeve pred tehniku. Biramo kamere koje pouzdano rade u ugostiteljskoj svakodnevici, a gosti ih ne primjećuju.',
      list: {
        '0': 'Nadzirati pristup kuhinji – samo ovlašteno osoblje',
        '1': 'Osigurati šank i blagajnu bez ometanja gostiju',
        '2': 'Vanjska terasa pod nadzorom u večernjim satima',
        '3': 'Dokumentirati dobavljače i dostavu bez praznina',
        '4': 'Postaviti oznake za goste i osoblje',
      },
      note: 'Napomena: zakonska dopuštenost videonadzora ovisi o slučaju. Savjetujemo vas, ne zamjenjujući pravni savjet.',
    },
    cta: {
      title: 'Vaše poslovanje zaslužuje siguran okvir',
      lead: 'Pokazujemo vam bez obveze gdje se videonadzor isplati, a gdje nije potreban.',
      primary: 'Zakažite termin savjetovanja',
      secondary: 'Otkrijte SSG Care',
    },
  },
};